

// export default AddMeasurementModal;
// import React, { useEffect, useRef, useState } from 'react';
// import axios from 'axios';
// import config from '../config';
// import { toast } from "react-toastify";

// const AddMeasurementModal = ({
//   measurementModalOpen,
//   setNewProduct,
//   handleMeasurementModalClose,
//   selectedStyle,
//   productsInOrder, // This is the ID of the current product
//   customerId,
//   products // The array of all products
// }) => {

//   const [styleFields, setStyleFields] = useState([]);
//   const [formData, setFormData] = useState({});
//   const [saving, setSaving] = useState(false);
//   const [loading, setLoading] = useState(false);

//   let productId = productsInOrder;

//   useEffect(() => {
//     let isMounted = true;

//     if (measurementModalOpen) {
//       setLoading(true);
//       setFormData({});
//       setStyleFields([]);

//       // 1. Get Field List
//       axios
//         .get(`${config.BASE_URL}/api/v1/measurementList?selectedStyle=${selectedStyle}`)
//         .then((styleListResponse) => {
//           if (!isMounted) return;

//           const styles = styleListResponse.data[0]?.fields?.value || [];
//           setStyleFields(styles);

//           // 2. Get Existing Data for THIS specific product
//           axios
//             .get(`${config.BASE_URL}/api/v1/getProductMeasurements/${productId}`)
//             .then((productResponse) => {
//               if (!isMounted) return;

//               const currentSavedMeasurements = productResponse.data?.measurements || {};

//               let finalFormData = {};

//               // Initialize form with defaults
//               styles.forEach((field) => {
//                 if (field.fieldType === "text" || field.fieldType === "number") {
//                   finalFormData[field.fieldkey] = "";
//                 } else if (field.fieldType === "select") {
//                   finalFormData[field.fieldkey] = field.defaultValue || field.options?.[0] || "";
//                 }
//               });

//               const hasExistingData = currentSavedMeasurements && Object.keys(currentSavedMeasurements).length > 0;

//               if (hasExistingData) {
//                 // Case A: Use existing saved data
//                 finalFormData = { ...finalFormData, ...currentSavedMeasurements };
//               } else {
//                 // Case B: Prefill Logic

//                 const getMeasurementsFromProduct = (prod) => {
//                     let m = prod.measurements;
//                     if (!m) return null;
//                     if (typeof m === 'string') {
//                         try { m = JSON.parse(m); } catch(e) { return null; }
//                     }
//                     return (m && Object.keys(m).length > 0) ? m : null;
//                 };

//                 // Check description first as per your debug logs, then style/style_name
//                 const getStyleName = (prod) => {
//                     const name = prod.description || prod.style_name || prod.style || "";
//                     return name.toLowerCase().trim();
//                 };

//                 const targetStyleLower = (selectedStyle || "").toLowerCase().trim();

//                 // --- PRIORITY 1: Find SAME STYLE (e.g., Jacket -> Jacket) ---
//                 let sourceProduct = products.find(p => {
//                     const sName = getStyleName(p);
//                     const hasM = getMeasurementsFromProduct(p);

//                     // Ensure we don't copy from self
//                     const isSelf = (String(p.id) === String(productId)) || (String(p._id) === String(productId));

//                     // Check exact match on style name (e.g. "jacket" === "jacket")
//                     return sName === targetStyleLower && !isSelf && hasM;
//                 });

//                 // --- PRIORITY 2: Find SUIT ---
//                 if (!sourceProduct) {
//                     sourceProduct = products.find(p => {
//                         const sName = getStyleName(p);
//                         const hasM = getMeasurementsFromProduct(p);
//                         return sName.includes('suit') && hasM;
//                     });
//                 }

//                 // Apply Data if Found
//                 if (sourceProduct) {
//                     const sourceMeasurements = getMeasurementsFromProduct(sourceProduct);
//                     const sourceName = sourceProduct.description || sourceProduct.style || "Unknown Style";
//                     console.log("Prefilling from:", sourceName);

//                     styles.forEach((field) => {
//                         const key = field.fieldkey;
//                         // Only copy if value exists and is not empty
//                         if (sourceMeasurements[key] !== undefined && sourceMeasurements[key] !== "") {
//                             finalFormData[key] = sourceMeasurements[key];
//                         }
//                     });
//                     toast.info(`Data copied from ${sourceName}`);
//                 }
//               }

//               setFormData(finalFormData);
//               setLoading(false);
//             })
//             .catch((err) => {
//               console.error("Error fetching product measurements:", err);
//               setFormData({});
//               setLoading(false);
//             });
//         })
//         .catch((error) => {
//           console.error("Error fetching style list:", error);
//           setLoading(false);
//         });
//     }

//     return () => { isMounted = false; };
//   }, [measurementModalOpen, selectedStyle, productId, customerId, products]);

//   const handleSaveProduct = () => {
//     setSaving(true);
//     axios
//       .put(`${config.BASE_URL}/api/v1/updateMeasurements/${productId}`, {
//         measurements: JSON.stringify(formData),
//       })
//       .then((response) => {
//         toast.success("Measurements saved successfully!");
//         handleMeasurementModalClose();
//         setFormData({});
//       })
//       .catch((error) => {
//         console.error("Error saving data:", error);
//         toast.error("Failed to save measurements.");
//       })
//       .finally(() => {
//         setSaving(false);
//       });
//   };

//   const handleInputChange = (key, value) => {
//     setFormData((prev) => ({ ...prev, [key]: value }));
//   };

//   if (!measurementModalOpen) return null;

//   return (
//     <div className="modal-overlay medium_width_popup">
//       <div className="modal-content">
//         <div className="popup_header">
//           <h4>Add Measurement ({selectedStyle})</h4>
//           <button type="button" onClick={handleMeasurementModalClose}>×</button>
//         </div>

//         {loading ? (
//           <div style={{ padding: '20px', textAlign: 'center' }}>
//             Loading measurements...
//           </div>
//         ) : (
//           <form>
//             {styleFields.map((field, index) => (
//               <div className="form-group row" key={index}>
//                 <label className="field_label">{field.label}</label>
//                 <div className="field_value">
//                   {field.fieldType === "select" ? (
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         handleInputChange(field.fieldkey, e.target.value)
//                       }
//                       value={formData[field.fieldkey] || ""}
//                     >
//                       {field.options.map((option, optIndex) => (
//                         <option key={optIndex} value={option}>
//                           {option}
//                         </option>
//                       ))}
//                     </select>
//                   ) : (
//                     <input
//                       type={field.fieldType === "number" ? "number" : "text"}
//                       className="form-control"
//                       value={formData[field.fieldkey] || ""}
//                       onChange={(e) =>
//                         handleInputChange(field.fieldkey, e.target.value)
//                       }
//                       placeholder=""
//                     />
//                   )}
//                 </div>
//               </div>
//             ))}

//             <div className="form-group row">
//               <label className="field_label">Style Remarks</label>
//               <div className="field_value">
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData["remarks"] || ""}
//                   onChange={(e) => handleInputChange("remarks", e.target.value)}
//                 />
//               </div>
//             </div>

//             <div className="form_footer">
//               <button
//                 type="button"
//                 onClick={handleSaveProduct}
//                 className="btn"
//                 disabled={saving}
//               >
//                 {saving ? "Saving..." : "Save"}
//               </button>
//             </div>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddMeasurementModal;

// import React, { useEffect, useRef, useState } from 'react';
// import axios from 'axios';
// import config from '../config';
// import { toast } from "react-toastify";

// // Helper to add numbers safely.
// function addMeasurement(originalValue, amountToAdd) {
//   if (!originalValue || originalValue === "") return "";
//   const num = parseFloat(originalValue);
//   if (isNaN(num)) return "";
//   return (num + amountToAdd).toFixed(2).toString(); // Return as string to fit input
// }

// const AddMeasurementModal = ({
//   measurementModalOpen,
//   setNewProduct,
//   handleMeasurementModalClose,
//   selectedStyle,
//   productsInOrder,
//   customerId,
//   products
// }) => {
//   console.log(products,"products")
//   const [styleFields, setStyleFields] = useState([]);
//   const [formData, setFormData] = useState({});
//   const [saving, setSaving] = useState(false);
//   const [loading, setLoading] = useState(false);

//   let productId = productsInOrder;

//   useEffect(() => {
//     let isMounted = true;

//     if (measurementModalOpen) {
//       setLoading(true);
//       setFormData({});
//       setStyleFields([]);

//       // 1. Get Field List
//       axios
//         .get(`${config.BASE_URL}/api/v1/measurementList?selectedStyle=${selectedStyle}`)
//         .then((styleListResponse) => {
//           if (!isMounted) return;

//           const styles = styleListResponse.data[0]?.fields?.value || [];
//           setStyleFields(styles);

//           // 2. Get Existing Data for THIS specific product
//           axios
//             .get(`${config.BASE_URL}/api/v1/getProductMeasurements/${productId}`)
//             .then((productResponse) => {
//               if (!isMounted) return;

//               const currentSavedMeasurements = productResponse.data?.measurements || {};
//               let finalFormData = {};

//               // Initialize form with defaults
//               styles.forEach((field) => {
//                 if (field.fieldType === "text" || field.fieldType === "number") {
//                   finalFormData[field.fieldkey] = "";
//                 } else if (field.fieldType === "select") {
//                   finalFormData[field.fieldkey] = field.defaultValue || field.options?.[0] || "";
//                 }
//               });

//               const hasExistingData = currentSavedMeasurements && Object.keys(currentSavedMeasurements).length > 0;

//               if (hasExistingData) {
//                 // CASE A: Use existing saved data
//                 finalFormData = { ...finalFormData, ...currentSavedMeasurements };
//               } else {
//                 // CASE B: PREFILL LOGIC

//                 const getMeasurementsFromProduct = (prod) => {
//                     let m = prod.measurements;
//                     if (!m) return null;
//                     if (typeof m === 'string') {
//                         try { m = JSON.parse(m); } catch(e) { return null; }
//                     }
//                     return (m && Object.keys(m).length > 0) ? m : null;
//                 };

//                 const getStyleName = (prod) => {
//                     const name = prod.description || prod.style_name || prod.style || "";
//                     return name.toLowerCase().trim();
//                 };

//                 const targetStyleLower = (selectedStyle || "").toLowerCase().trim();
//                 let sourceProduct = null;
//                 let isUsingJacketDataForOtherStyle = false;

//                 // --- PRIORITY 1: Find SAME STYLE (e.g. Vest -> Vest) ---
//                 sourceProduct = products.find(p => {
//                     const sName = getStyleName(p);
//                     const hasM = getMeasurementsFromProduct(p);
//                     const isSelf = (String(p.id) === String(productId)) || (String(p._id) === String(productId));
//                     return sName === targetStyleLower && !isSelf && hasM;
//                 });

//                 // --- PRIORITY 2: If Vest or Shirt, find Jacket/Suit ---
//                 if (!sourceProduct && (targetStyleLower === 'vest' || targetStyleLower === 'shirt')) {
//                     sourceProduct = products.find(p => {
//                         const sName = getStyleName(p);
//                         const hasM = getMeasurementsFromProduct(p);
//                         // Look for explicit Jacket OR Suit (Suit contains Jacket measurements)
//                         return (sName === 'jacket' || sName.includes('suit')) && hasM;
//                     });
//                     if (sourceProduct) isUsingJacketDataForOtherStyle = true;
//                 }

//                 // --- PRIORITY 3: Fallback to Suit (General) ---
//                 if (!sourceProduct) {
//                     sourceProduct = products.find(p => {
//                         const sName = getStyleName(p);
//                         const hasM = getMeasurementsFromProduct(p);
//                         return sName.includes('suit') && hasM;
//                     });
//                 }

//                 // --- APPLY DATA ---
//                 if (sourceProduct) {
//                     const sourceMeasurements = getMeasurementsFromProduct(sourceProduct);
//                     const sourceName = sourceProduct.description || sourceProduct.style || "Unknown";
//                     console.log(`Prefilling ${targetStyleLower} from ${sourceName}`);

//                     styles.forEach((field) => {
//                         const key = field.fieldkey;
//                         let valueToCopy = sourceMeasurements[key];

//                         // --- SPECIAL LOGIC FOR VEST (from Jacket/Suit) ---
//                         if (targetStyleLower === 'vest' && isUsingJacketDataForOtherStyle) {
//                             // Exclude Length and Hip
//                             if (key.toLowerCase().includes('length') || key.toLowerCase().includes('hip')) {
//                                 return; // Skip this iteration, leave empty
//                             }
//                         }

//                         // --- SPECIAL LOGIC FOR SHIRT (from Jacket/Suit) ---
//                         if (targetStyleLower === 'shirt' && isUsingJacketDataForOtherStyle) {

//                             // 1. Waist Upper -> use Waist Lower from Jacket
//                             if (key === 'waistUpper') {
//                                 valueToCopy = sourceMeasurements['waistLower'];
//                             }
//                             // 2. Shoulder -> Jacket Shoulder + 0.25
//                             else if (key.toLowerCase().includes('shoulder')) {
//                                 valueToCopy = addMeasurement(sourceMeasurements[key], 0.25);
//                             }
//                             // 3. Sleeve -> Jacket Sleeve + 0.5
//                             else if (key.toLowerCase().includes('sleeve')) {
//                                 valueToCopy = addMeasurement(sourceMeasurements[key], 0.5);
//                             }
//                         }

//                         // Final Check and Assignment
//                         if (valueToCopy !== undefined && valueToCopy !== "") {
//                             finalFormData[key] = valueToCopy;
//                         }
//                     });
//                     toast.info(`Data copied from ${sourceName}`);
//                 }
//               }

//               setFormData(finalFormData);
//               setLoading(false);
//             })
//             .catch((err) => {
//               console.error("Error fetching product measurements:", err);
//               setFormData({});
//               setLoading(false);
//             });
//         })
//         .catch((error) => {
//           console.error("Error fetching style list:", error);
//           setLoading(false);
//         });
//     }

//     return () => { isMounted = false; };
//   }, [measurementModalOpen, selectedStyle, productId, customerId, products]);

//   const handleSaveProduct = () => {
//     setSaving(true);
//     axios
//       .put(`${config.BASE_URL}/api/v1/updateMeasurements/${productId}`, {
//         measurements: JSON.stringify(formData),
//       })
//       .then((response) => {
//         toast.success("Measurements saved successfully!");
//         handleMeasurementModalClose();
//         setFormData({});
//         window.location.reload();
//       })
//       .catch((error) => {
//         console.error("Error saving data:", error);
//         toast.error("Failed to save measurements.");
//       })
//       .finally(() => {
//         setSaving(false);
//       });
//   };

//   const handleInputChange = (key, value) => {
//     setFormData((prev) => ({ ...prev, [key]: value }));
//   };

//   if (!measurementModalOpen) return null;

//   return (
//     <div className="modal-overlay medium_width_popup">
//       <div className="modal-content">
//         <div className="popup_header">
//           <h4>Add Measurement ({selectedStyle})</h4>
//           <button type="button" onClick={handleMeasurementModalClose}>×</button>
//         </div>

//         {loading ? (
//           <div style={{ padding: '20px', textAlign: 'center' }}>
//             Loading measurements...
//           </div>
//         ) : (
//           <form>
//             {styleFields.map((field, index) => (
//               <div className="form-group row" key={index}>
//                 <label className="field_label">{field.label}</label>
//                 <div className="field_value">
//                   {field.fieldType === "select" ? (
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         handleInputChange(field.fieldkey, e.target.value)
//                       }
//                       value={formData[field.fieldkey] || ""}
//                     >
//                       {field.options.map((option, optIndex) => (
//                         <option key={optIndex} value={option}>
//                           {option}
//                         </option>
//                       ))}
//                     </select>
//                   ) : (
//                     <input
//                       type={field.fieldType === "number" ? "number" : "text"}
//                       className="form-control"
//                       value={formData[field.fieldkey] || ""}
//                       onChange={(e) =>
//                         handleInputChange(field.fieldkey, e.target.value)
//                       }
//                       placeholder=""
//                     />
//                   )}
//                 </div>
//               </div>
//             ))}

//             <div className="form-group row">
//               <label className="field_label">Style Remarks</label>
//               <div className="field_value">
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData["remarks"] || ""}
//                   onChange={(e) => handleInputChange("remarks", e.target.value)}
//                 />
//               </div>
//             </div>

//             <div className="form_footer">
//               <button
//                 type="button"
//                 onClick={handleSaveProduct}
//                 className="btn"
//                 disabled={saving}
//               >
//                 {saving ? "Saving..." : "Save"}
//               </button>
//             </div>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// // export default AddMeasurementModal;
// import React, { useEffect, useRef, useState } from 'react';
// import axios from 'axios';
// import config from '../config';
// import { toast } from "react-toastify";

// // Helper to add numbers safely.
// function addMeasurement(originalValue, amountToAdd) {
//   if (!originalValue || originalValue === "") return "";
//   const num = parseFloat(originalValue);
//   if (isNaN(num)) return "";
//   return (num + amountToAdd).toFixed(2).toString();
// }

// const AddMeasurementModal = ({
//   measurementModalOpen,
//   setNewProduct,
//   handleMeasurementModalClose,
//   selectedStyle,
//   productsInOrder,
//   customerId,
//   products
// }) => {

//   const [styleFields, setStyleFields] = useState([]);
//   const [formData, setFormData] = useState({});
//   const [saving, setSaving] = useState(false);
//   const [loading, setLoading] = useState(false);

//   let productId = productsInOrder;

//   useEffect(() => {
//     let isMounted = true;

//     if (measurementModalOpen) {
//       setLoading(true);
//       setFormData({});
//       setStyleFields([]);

//       // 1. Get Field List
//       axios
//         .get(`${config.BASE_URL}/api/v1/measurementList?selectedStyle=${selectedStyle}`)
//         .then((styleListResponse) => {
//           if (!isMounted) return;

//           const styles = styleListResponse.data[0]?.fields?.value || [];
//           setStyleFields(styles);

//           // 2. Get Existing Data for THIS specific product
//           axios
//             .get(`${config.BASE_URL}/api/v1/getProductMeasurements/${productId}`)
//             .then((productResponse) => {
//               if (!isMounted) return;

//               const currentSavedMeasurements = productResponse.data?.measurements || {};
//               let finalFormData = {};

//               // Initialize form with defaults
//               styles.forEach((field) => {
//                 if (field.fieldType === "text" || field.fieldType === "number") {
//                   finalFormData[field.fieldkey] = "";
//                 } else if (field.fieldType === "select") {
//                   finalFormData[field.fieldkey] = field.defaultValue || field.options?.[0] || "";
//                 }
//               });

//               const hasExistingData = currentSavedMeasurements && Object.keys(currentSavedMeasurements).length > 0;

//               if (hasExistingData) {
//                 // CASE A: Use existing saved data
//                 finalFormData = { ...finalFormData, ...currentSavedMeasurements };
//               } else {
//                 // CASE B: PREFILL LOGIC

//                 const getMeasurementsFromProduct = (prod) => {
//                     let m = prod.measurements;
//                     if (!m) return null;
//                     if (typeof m === 'string') {
//                         try { m = JSON.parse(m); } catch(e) { return null; }
//                     }
//                     return (m && Object.keys(m).length > 0) ? m : null;
//                 };

//                 const getStyleName = (prod) => {
//                     const name = prod.description || prod.style_name || prod.style || "";
//                     return name.toLowerCase().trim();
//                 };

//                 // --- NEW: Helper to check Customer ID match ---
//                 const isSameCustomer = (prod) => {
//                     if (!prod.customer_id || !customerId) return false;

//                     // Handle cases where ID might be an object (MongoID) or a string
//                     const currentIdStr = typeof customerId === 'object' ? customerId._id : customerId;
//                     const prodIdStr = typeof prod.customer_id === 'object' ? prod.customer_id._id : prod.customer_id;

//                     return String(currentIdStr) === String(prodIdStr);
//                 };

//                 const targetStyleLower = (selectedStyle || "").toLowerCase().trim();
//                 let sourceProduct = null;
//                 let isUsingJacketDataForOtherStyle = false;

//                 // List of styles that should look for Jacket/Suit if they are empty
//                 const upperBodyStyles = ['vest', 'shirt', 'overcoat', 'tuxedo', 'safari', 'sherwani', 'indowestern'];

//                 // --- PRIORITY 1: Find SAME STYLE (e.g. Overcoat -> Overcoat) for SAME CUSTOMER ---
//                 sourceProduct = products.find(p => {
//                     const sName = getStyleName(p);
//                     const hasM = getMeasurementsFromProduct(p);
//                     const isSelf = (String(p.id) === String(productId)) || (String(p._id) === String(productId));

//                     // 1. Name Match, 2. Not Self, 3. Has Data, 4. SAME CUSTOMER
//                     return sName === targetStyleLower && !isSelf && hasM && isSameCustomer(p);
//                 });

//                 // --- PRIORITY 2: If Upper Body (Vest, Shirt, Overcoat, Tuxedo), find Jacket/Suit for SAME CUSTOMER ---
//                 if (!sourceProduct && upperBodyStyles.includes(targetStyleLower)) {
//                     sourceProduct = products.find(p => {
//                         const sName = getStyleName(p);
//                         const hasM = getMeasurementsFromProduct(p);

//                         // Look for explicit Jacket OR Suit
//                         return (sName === 'jacket' || sName.includes('suit')) && hasM && isSameCustomer(p);
//                     });
//                     if (sourceProduct) isUsingJacketDataForOtherStyle = true;
//                 }

//                 // --- PRIORITY 3: Fallback to Suit (General) for SAME CUSTOMER ---
//                 if (!sourceProduct) {
//                     sourceProduct = products.find(p => {
//                         const sName = getStyleName(p);
//                         const hasM = getMeasurementsFromProduct(p);
//                         return sName.includes('suit') && hasM && isSameCustomer(p);
//                     });
//                 }

//                 // --- APPLY DATA ---
//                 if (sourceProduct) {
//                     const sourceMeasurements = getMeasurementsFromProduct(sourceProduct);
//                     const sourceName = sourceProduct.description || sourceProduct.style || "Unknown";
//                     console.log(`Prefilling ${targetStyleLower} from ${sourceName}`);

//                     styles.forEach((field) => {
//                         const key = field.fieldkey;
//                         let valueToCopy = sourceMeasurements[key];

//                         // --- SPECIAL LOGIC FOR VEST ---
//                         if (targetStyleLower === 'vest' && isUsingJacketDataForOtherStyle) {
//                             if (key.toLowerCase().includes('length') || key.toLowerCase().includes('hip')) {
//                                 return; // Skip
//                             }
//                         }

//                         // --- SPECIAL LOGIC FOR SHIRT ---
//                         if (targetStyleLower === 'shirt' && isUsingJacketDataForOtherStyle) {
//                             if (key === 'waistUpper') {
//                                 valueToCopy = sourceMeasurements['waistLower'];
//                             }
//                             else if (key.toLowerCase().includes('shoulder')) {
//                                 valueToCopy = addMeasurement(sourceMeasurements[key], 0.25);
//                             }
//                             else if (key.toLowerCase().includes('sleeve')) {
//                                 valueToCopy = addMeasurement(sourceMeasurements[key], 0.5);
//                             }
//                         }


//                         if (valueToCopy !== undefined && valueToCopy !== "") {
//                             finalFormData[key] = valueToCopy;
//                         }
//                     });
//                     toast.info(`Data copied from ${sourceName}`);
//                 }
//               }

//               setFormData(finalFormData);
//               setLoading(false);
//             })
//             .catch((err) => {
//               console.error("Error fetching product measurements:", err);
//               setFormData({});
//               setLoading(false);
//             });
//         })
//         .catch((error) => {
//           console.error("Error fetching style list:", error);
//           setLoading(false);
//         });
//     }

//     return () => { isMounted = false; };
//   }, [measurementModalOpen, selectedStyle, productId, customerId, products]);

//   const handleSaveProduct = () => {
//     setSaving(true);
//     axios
//       .put(`${config.BASE_URL}/api/v1/updateMeasurements/${productId}`, {
//         measurements: JSON.stringify(formData),
//       })
//       .then((response) => {
//         toast.success("Measurements saved successfully!");
//         handleMeasurementModalClose();
//         setFormData({});
//         // Reload to reflect changes if needed
//         // window.location.reload(); 
//       })
//       .catch((error) => {
//         console.error("Error saving data:", error);
//         toast.error("Failed to save measurements.");
//       })
//       .finally(() => {
//         setSaving(false);
//       });
//   };

//   const handleInputChange = (key, value) => {
//     setFormData((prev) => ({ ...prev, [key]: value }));
//   };

//   if (!measurementModalOpen) return null;

//   return (
//     <div className="modal-overlay medium_width_popup">
//       <div className="modal-content">
//         <div className="popup_header">
//           <h4>Add Measurement ({selectedStyle})</h4>
//           <button type="button" onClick={handleMeasurementModalClose}>×</button>
//         </div>

//         {loading ? (
//           <div style={{ padding: '20px', textAlign: 'center' }}>
//             Loading measurements...
//           </div>
//         ) : (
//           <form>
//             {styleFields.map((field, index) => (
//               <div className="form-group row" key={index}>
//                 <label className="field_label">{field.label}</label>
//                 <div className="field_value">
//                   {field.fieldType === "select" ? (
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         handleInputChange(field.fieldkey, e.target.value)
//                       }
//                       value={formData[field.fieldkey] || ""}
//                     >
//                       {field.options.map((option, optIndex) => (
//                         <option key={optIndex} value={option}>
//                           {option}
//                         </option>
//                       ))}
//                     </select>
//                   ) : (
//                     <input
//                       type={field.fieldType === "number" ? "number" : "text"}
//                       className="form-control"
//                       value={formData[field.fieldkey] || ""}
//                       onChange={(e) =>
//                         handleInputChange(field.fieldkey, e.target.value)
//                       }
//                       placeholder=""
//                     />
//                   )}
//                 </div>
//               </div>
//             ))}

//             <div className="form-group row">
//               <label className="field_label">Style Remarks</label>
//               <div className="field_value">
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData["remarks"] || ""}
//                   onChange={(e) => handleInputChange("remarks", e.target.value)}
//                 />
//               </div>
//             </div>

//             <div className="form_footer">
//               <button
//                 type="button"
//                 onClick={handleSaveProduct}
//                 className="btn"
//                 disabled={saving}
//               >
//                 {saving ? "Saving..." : "Save"}
//               </button>
//             </div>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddMeasurementModal;

import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import config from '../config';
import { toast } from "react-toastify";

// Helper to add numbers safely.
function addMeasurement(originalValue, amountToAdd) {
  if (!originalValue || originalValue === "") return "";
  const num = parseFloat(originalValue);
  if (isNaN(num)) return "";
  return (num + amountToAdd).toFixed(2).toString();
}

const AddMeasurementModal = ({
  measurementModalOpen,
  setNewProduct,
  handleMeasurementModalClose,
  selectedStyle,
  productsInOrder,
  customerId,
  products,
  onMeasurementsUpdated
}) => {

  const [styleFields, setStyleFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  let productId = productsInOrder;


  useEffect(() => {
    let isMounted = true;

    if (measurementModalOpen) {
      setLoading(true);
      setFormData({});
      setStyleFields([]);

      axios
        .get(`${config.BASE_URL}/api/v1/measurementList?selectedStyle=${selectedStyle}`)
        .then((styleListResponse) => {
          if (!isMounted) return;

          const styles = styleListResponse.data[0]?.fields?.value || [];
          setStyleFields(styles);

          axios
            .get(`${config.BASE_URL}/api/v1/getProductMeasurements/${productId}`)
            .then((productResponse) => {
              if (!isMounted) return;

              const currentSavedMeasurements = productResponse.data?.measurements || {};
              let finalFormData = {};

              // Initialize form
              styles.forEach((field) => {
                if (field.fieldType === "text" || field.fieldType === "number") {
                  finalFormData[field.fieldkey] = "";
                } else if (field.fieldType === "select") {
                  finalFormData[field.fieldkey] = field.defaultValue || field.options?.[0] || "";
                }
              });

              if (currentSavedMeasurements && Object.keys(currentSavedMeasurements).length > 0) {
                finalFormData = { ...finalFormData, ...currentSavedMeasurements };
              } else {

                // --- HELPER FUNCTIONS ---
                const extractId = (data) => {
                  if (!data) return "MISSING";
                  if (typeof data === 'string') return data;
                  if (typeof data === 'object' && data._id) return data._id;
                  if (typeof data === 'object' && data.id) return data.id;
                  return String(data);
                };

                const isSameCustomer = (prod) => {
                  const myCustId = extractId(customerId);
                  const prodCustId = extractId(prod.customer_id);
                  return String(myCustId) === String(prodCustId);
                };

                const getMeasurementsFromProduct = (prod) => {
                  let m = prod.measurements;
                  if (!m) return null;
                  if (typeof m === 'string') {
                    try { m = JSON.parse(m); } catch (e) { return null; }
                  }
                  return (m && Object.keys(m).length > 0) ? m : null;
                };

                const getStyleName = (prod) => {
                  const name = prod.description || prod.style_name || prod.style || "";
                  return name.toLowerCase().trim();
                };

                // --- PRIORITY CONFIGURATION ---
                const targetStyleLower = (selectedStyle || "").toLowerCase().trim();
                let sourceProduct = null;
                let isUsingFallbackData = false;

                const strictModeStyles = ['overcoat', 'tuxedo'];
                const reversedProducts = [...products].reverse();
              

                // ---------------------------------------------------------
                // STEP 1: EXACT OR SIMILAR NAME SEARCH
                // ---------------------------------------------------------
                sourceProduct = reversedProducts.find((p) => {
                  const sName = getStyleName(p);
                  const hasM = getMeasurementsFromProduct(p);
                  const isSelf = (String(p.id) === String(productId)) || (String(p._id) === String(productId));

                  // 1. Check Name
                  const nameMatch = sName === targetStyleLower || sName.includes(targetStyleLower);

                  // 2. Check Customer
                  const sameCust = isSameCustomer(p);

                  return nameMatch && !isSelf && hasM && sameCust;
                });

                // ---------------------------------------------------------
                // STEP 2: FALLBACK SEARCH
                // ---------------------------------------------------------
                // if (!sourceProduct) {
                //   if (!strictModeStyles.includes(targetStyleLower)) {

                //     sourceProduct = reversedProducts.find((p) => {
                //       const sName = getStyleName(p);
                //       const hasM = getMeasurementsFromProduct(p);
                //       const isSelf = (String(p.id) === String(productId)) || (String(p._id) === String(productId));
                //       const sameCust = isSameCustomer(p);

                //       const isSuitOrJacket = sName === 'jacket' || sName.includes('suit');

                //       return isSuitOrJacket && !isSelf && hasM && sameCust;
                //     });

                //     if (sourceProduct) {
                //       isUsingFallbackData = true;
                //     }
                //   }
                // }

                if (!sourceProduct) {
                  // Only use fallback if the target isn't strictly restricted
                  if (!strictModeStyles.includes(targetStyleLower)) {

                    sourceProduct = reversedProducts.find((p) => {
                      const sName = getStyleName(p);
                      const hasM = getMeasurementsFromProduct(p);
                      const isSelf = (String(p.id) === String(productId)) || (String(p._id) === String(productId));
                      const sameCust = isSameCustomer(p);

                      // New condition: Check for Jacket, Suit, OR Tuxedo
                      const isSuitJacketOrTux =
                        sName === 'jacket' ||
                        sName.includes('suit') ||
                        sName.includes('tuxedo');

                      return isSuitJacketOrTux && !isSelf && hasM && sameCust;
                    });

                    if (sourceProduct) {
                      isUsingFallbackData = true;
                      console.log("Using Fallback Data from:", getStyleName(sourceProduct));
                    }
                  }
                }

                // --- APPLY DATA ---
                if (sourceProduct) {
                  const sourceMeasurements = getMeasurementsFromProduct(sourceProduct);
                  const sourceName = sourceProduct.description || sourceProduct.style || "Unknown";

                  styles.forEach((field) => {
                    const key = field.fieldkey;
                    if ((targetStyleLower === 'shirt' || targetStyleLower === 'vest') && key === 'tuxRemarks') {
                      // Don't copy tuxRemarks into the shirt/vest form data
                      return;
                    }
                    let valueToCopy = sourceMeasurements[key];

                    if (isUsingFallbackData) {
                      if (targetStyleLower === 'vest') {
                        if (key.toLowerCase().includes('length') || key.toLowerCase().includes('hip')) return;
                      }
                      if (targetStyleLower === 'shirt') {
                        if (key === 'waistUpper') valueToCopy = sourceMeasurements['waistLower'];
                        else if (key.toLowerCase().includes('shoulder')) valueToCopy = addMeasurement(sourceMeasurements[key], 0.25);
                        else if (key.toLowerCase().includes('sleeve')) valueToCopy = addMeasurement(sourceMeasurements[key], 0.5);
                      }
                    }

                    if (valueToCopy !== undefined && valueToCopy !== "") {
                      finalFormData[key] = valueToCopy;
                    }
                  });
                  toast.info(`Data copied from ${sourceName}`);
                }
              }

              setFormData(finalFormData);
              setLoading(false);
            })
            .catch((err) => {
              console.error("Error fetching product measurements:", err);
              setFormData({});
              setLoading(false);
            });
        })
        .catch((error) => {
          console.error("Error fetching style list:", error);
          setLoading(false);
        });
    }

    return () => { isMounted = false; };
  }, [measurementModalOpen, selectedStyle, productId, customerId, products]);

  // const handleSaveProduct = () => {
  //   setSaving(true);
  //   axios
  //     .put(`${config.BASE_URL}/api/v1/updateMeasurements/${productId}`, {
  //       measurements: JSON.stringify(formData),
  //     })
  //     .then((response) => {
  //       toast.success("Measurements saved successfully!");
  //       handleMeasurementModalClose();
  //       setFormData({});
  //       if (onMeasurementsUpdated) {
  //         onMeasurementsUpdated();
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error saving data:", error);
  //       toast.error("Failed to save measurements.");
  //     })
  //     .finally(() => {
  //       setSaving(false);
  //     });
  // };

  // const handleSaveProduct = async () => {
  //     setSaving(true);
  //     try {
  //       // 1. Save the current product first
  //       await axios.put(`${config.BASE_URL}/api/v1/updateMeasurements/${productId}`, {
  //         measurements: JSON.stringify(formData),
  //       });

  //       // 2. Define target styles that trigger a sync
  //       const currentStyleLower = (selectedStyle || "").toLowerCase().trim();
  //       const isSourceStyle = 
  //         currentStyleLower === 'jacket' || 
  //         currentStyleLower.includes('suit') || 
  //         currentStyleLower.includes('tuxedo');

  //       // 3. If saving a Jacket/Tux, look for Vest/Shirt to update
  //       if (isSourceStyle) {
  //         const syncPromises = products.map((prod) => {
  //           const prodName = (prod.description || prod.style_name || prod.style || "").toLowerCase();
  //           const prodId = prod.id || prod._id;

  //           // Skip if it's the same product we just saved
  //           if (String(prodId) === String(productId)) return null;

  //           let updatedMeasurements = null;

  //           // Logic for VEST
  //           if (prodName.includes('vest')) {
  //             updatedMeasurements = { ...formData };
  //             // Measurement condition: exclude length and hip for vest
  //             Object.keys(updatedMeasurements).forEach(key => {
  //               if (key.toLowerCase().includes('length') || key.toLowerCase().includes('hip')) {
  //                 delete updatedMeasurements[key];
  //               }
  //             });
  //           }

  //           // Logic for SHIRT
  //           if (prodName.includes('shirt')) {
  //             updatedMeasurements = { ...formData };
  //             // Apply your specific shirt conditions
  //             if (updatedMeasurements['waistLower']) {
  //                 updatedMeasurements['waistUpper'] = updatedMeasurements['waistLower'];
  //             }

  //             Object.keys(updatedMeasurements).forEach(key => {
  //               if (key.toLowerCase().includes('shoulder')) {
  //                 updatedMeasurements[key] = addMeasurement(updatedMeasurements[key], 0.25);
  //               } else if (key.toLowerCase().includes('sleeve')) {
  //                 updatedMeasurements[key] = addMeasurement(updatedMeasurements[key], 0.5);
  //               }

  //               // Don't copy tuxRemarks to shirt
  //               if (key === 'tuxRemarks') delete updatedMeasurements[key];
  //             });
  //           }

  //           // If we found a match, update that product via API
  //           if (updatedMeasurements) {
  //             return axios.put(`${config.BASE_URL}/api/v1/updateMeasurements/${prodId}`, {
  //               measurements: JSON.stringify(updatedMeasurements),
  //             });
  //           }
  //           return null;
  //         }).filter(p => p !== null);

  //         if (syncPromises.length > 0) {
  //           await Promise.all(syncPromises);

  //         }
  //       }

  //       toast.success("Measurements saved successfully!");
  //       handleMeasurementModalClose();
  //       setFormData({});
  //       if (onMeasurementsUpdated) onMeasurementsUpdated();

  //     } catch (error) {
  //       console.error("Error saving data:", error);
  //       toast.error("Failed to save measurements.");
  //     } finally {
  //       setSaving(false);
  //     }
  //   };


  const handleSaveProduct = async () => {
    setSaving(true);

    // --- HELPER FOR CUSTOMER MATCHING ---
    const extractId = (data) => {
      if (!data) return null;
      if (typeof data === 'string') return data;
      if (typeof data === 'object' && data._id) return data._id;
      if (typeof data === 'object' && data.id) return data.id;
      return String(data);
    };

    const currentCustomerId = extractId(customerId);

    try {
      // 1. Save the primary product
      await axios.put(`${config.BASE_URL}/api/v1/updateMeasurements/${productId}`, {
        measurements: JSON.stringify(formData),
      });

      // 2. Determine if this style should trigger a sync
      const currentStyleLower = (selectedStyle || "").toLowerCase().trim();
      const isSourceStyle =
        currentStyleLower === 'jacket' ||
        currentStyleLower.includes('suit') ||
        currentStyleLower.includes('tuxedo');

      if (isSourceStyle) {
        const syncPromises = products.map((prod) => {
          const prodName = (prod.description || prod.style_name || prod.style || "").toLowerCase();
          const prodId = prod.id || prod._id;
          const prodCustId = extractId(prod.customer_id);

          // --- VALIDATION CHECKS ---
          // 1. Skip if it's the same product
          if (String(prodId) === String(productId)) return null;

          // 2. CRITICAL: Skip if the customer IDs don't match
          if (String(prodCustId) !== String(currentCustomerId)) return null;

          let updatedMeasurements = null;

          // Logic for VEST
          if (prodName.includes('vest')) {
            updatedMeasurements = { ...formData };
            Object.keys(updatedMeasurements).forEach(key => {
              if (key.toLowerCase().includes('length') || key.toLowerCase().includes('hip')) {
                delete updatedMeasurements[key];
              }
            });
          }

          // Logic for SHIRT
          if (prodName.includes('shirt')) {
            updatedMeasurements = { ...formData };
            if (updatedMeasurements['waistLower']) {
              updatedMeasurements['waistUpper'] = updatedMeasurements['waistLower'];
            }

            Object.keys(updatedMeasurements).forEach(key => {
              const lowerKey = key.toLowerCase();

              // ONLY numeric shoulder measurement
              if (
                lowerKey === 'shoulders' ||
                lowerKey.includes('shoulders')
              ) {
                updatedMeasurements[key] = addMeasurement(updatedMeasurements[key], 0.25);
              } else if (key.toLowerCase().includes('sleeve')) {
                updatedMeasurements[key] = addMeasurement(updatedMeasurements[key], 0.5);
              }
              if (key === 'tuxRemarks') delete updatedMeasurements[key];
            });
          }

          if (updatedMeasurements) {
            return axios.put(`${config.BASE_URL}/api/v1/updateMeasurements/${prodId}`, {
              measurements: JSON.stringify(updatedMeasurements),
            });
          }
          return null;
        }).filter(p => p !== null);

        if (syncPromises.length > 0) {
          await Promise.all(syncPromises);
        }
      }

      toast.success("Measurements saved successfully!");
      handleMeasurementModalClose();
      setFormData({});
      if (onMeasurementsUpdated) onMeasurementsUpdated();

    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to save measurements.");
    } finally {
      setSaving(false);
    }
  };
  const handleInputChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  if (!measurementModalOpen) return null;

  return (
    <div className="modal-overlay medium_width_popup">
      <div className="modal-content">
        <div className="popup_header">
          <h4>Add Measurement ({selectedStyle})</h4>
          <button type="button" onClick={handleMeasurementModalClose}>×</button>
        </div>

        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            Loading measurements...
          </div>
        ) : (
          <form>
            {styleFields.map((field, index) => (
              <div className="form-group row" key={index}>
                <label className="field_label">{field.label}</label>
                <div className="field_value">
                  {field.fieldType === "select" ? (
                    <select
                      className="form-control"
                      onChange={(e) =>
                        handleInputChange(field.fieldkey, e.target.value)
                      }
                      value={formData[field.fieldkey] || ""}
                    >
                      {field.options.map((option, optIndex) => (
                        <option key={optIndex} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={field.fieldType === "number" ? "number" : "text"}
                      className="form-control"
                      value={formData[field.fieldkey] || ""}
                      onChange={(e) =>
                        handleInputChange(field.fieldkey, e.target.value)
                      }
                      placeholder=""
                    />
                  )}
                </div>
              </div>
            ))}

            {/* <div className="form-group row">
              <label className="field_label">Style Remarks</label>
              <div className="field_value">
                <input
                  type="text"
                  className="form-control"
                  value={formData["remarks"] || ""}
                  onChange={(e) => handleInputChange("remarks", e.target.value)}
                />
              </div>
            </div> */}

            <div className="form_footer">
              <button
                type="button"
                onClick={handleSaveProduct}
                className="btn"
                disabled={saving}
              >
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default AddMeasurementModal;